import React from 'react';
import { labels } from '../data/labels';

function Legend(props) {
    return (
        <div className="leggenda-giocab my-4">
            <p className="leggenda-giocab__titolo">{labels['legend.title']}</p>
            <div className="leggenda-giocab__gruppi-container">
                <div className="leggenda-giocab__gruppo-leggenda">
                    <span className="leggenda-giocab__icona-giocab leggenda-giocab__icona-giocab--1"></span>
                    <p className="leggenda-giocab__descrizione-giocab">{labels['legend.single']}</p>
                </div>
                <div className="leggenda-giocab__gruppo-leggenda">
                    <span className="leggenda-giocab__icona-giocab leggenda-giocab__icona-giocab--2"></span>
                    <p className="leggenda-giocab__descrizione-giocab">{labels['legend.double']}</p>
                </div>
                <div className="leggenda-giocab__gruppo-leggenda">
                    <span className="leggenda-giocab__icona-giocab leggenda-giocab__icona-giocab--3"></span>
                    <p className="leggenda-giocab__descrizione-giocab">{labels['legend.triple']}</p>
                </div>
                <div className="leggenda-giocab__gruppo-leggenda">
                    <span className="leggenda-giocab__icona-giocab leggenda-giocab__icona-giocab--4"></span>
                    <p className="leggenda-giocab__descrizione-giocab">{labels['legend.quadruple']}</p>
                </div>
                <div className="leggenda-giocab__gruppo-leggenda">
                    <span className="leggenda-giocab__icona-giocab leggenda-giocab__icona-giocab--5"></span>
                    <p className="leggenda-giocab__descrizione-giocab">{labels['legend.quintuple']}</p>
                </div>
            </div>
        </div>
    )
}

export default Legend;